import { FC, useRef, useState } from "react"
import { isMobileOrTablet } from "src/helpers";
import { useOnClickOutside } from "src/hooks/useClickOutside";


const PatientDashboardTitle: FC = (): JSX.Element => {
  const [infoIconIndex, changeInfoIconIndex] = useState<number>(-1);
  const toggleIconRef = useRef<HTMLElement | null>(null);

  useOnClickOutside(toggleIconRef, () => {
    changeInfoIconIndex(-1);
  });

  const handleIconClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();
    changeInfoIconIndex(infoIconIndex !== 4 ? 4 : -1);
  };

    return (
        <span>Patients
            {isMobileOrTablet() ? (
                <i ref={toggleIconRef} className="bi bi-question-circle-fill info-icon ms-2" onClick={handleIconClick}>
                    <span className={`info-icon-detail bg-dark ${infoIconIndex > 0 ? "d-block" : "d-none"}`}
                        dangerouslySetInnerHTML={{
                            __html: `<p class="m-0 text-start">This dashboard lists every patient that your office has ever submitted to MQC. Each patient is listed only once by their most recent treatment status.  Search function and the ability to download an Excel report of your patients and all  their cases at MQC is also available.</p>`
                        }}
                    ></span>
                </i>
            ) : (
                <i className="bi bi-question-circle-fill ms-2"
                   title="This dashboard lists every patient that your office has ever submitted to MQC. Each patient is
                   listed only once by their most recent treatment status. Search function and the ability to download
                   an Excel report of your patients and all  their cases at MQC is also available.">
                </i>
            )}
        </span>
    );
}

export default PatientDashboardTitle
